import React, { Component } from 'react';
import { connect } from 'react-redux';

import { breaksToBrs } from '../../../../utils/formatting';

import styles from './_styles/ViewSectionElement.module.scss';

const allActionCreators = Object.assign({});

export class ViewSectionElement extends Component {

	formatValue() {
		if(this.props.fieldSchema?.type === 'toggle') {
			return this.props.value 
				? this.props.fieldSchema?.toggleTrue || 'True'
				: this.props.fieldSchema?.toggleFalse || 'False'
		} else if(this.props.fieldSchema?.type === 'textarea') {
			return breaksToBrs(this.props.value);
		} else if(this.props.fieldSchema?.formatOnDisplay) {
			return this.props.fieldSchema.formatOnDisplay(this.props.value);
		} else if(this.props.fieldSchema?.activateUrl && this.props.value?.startsWith('http')) {
			return `<a href='${this.props.value}' target='_blank' rel='noopener noreferrer'>${this.props.value}</a>`;
		}
		return this.props.value;
	}

	formatRange(variants, dataKey, formatMethod = null) {
		
		const values = variants
			.map(val => parseFloat(val[dataKey]))
			.filter(num => !Number.isNaN(num));

		if(values.length === 0) {
			return '';
		}

		const min = Math.min(...values);
		const max = Math.max(...values);

		if(min === max) {
			return formatMethod ? formatMethod(min) : min;
		} else {
			return `${formatMethod ? formatMethod(min) : min} - ${formatMethod ? formatMethod(max) : max}`;
		}
	}

	formatVariantValues() {
		
		const dataKey = this.props.fieldSchema?.apiKey;
		const respData = {};
		const labels = [
			'14k', '18k', 'Platinum'
		];
		
		if(this.props.fieldSchema?.useApiData && this.props.apiDataPending) {
			return <div className={styles.variantDataLoading}>Loading</div>
		}

		const variantApiData = this.props.fieldSchema?.useApiData && this.props.apiData 
			? this.props.apiData.map(({ material_type, karat, ...rest }) => ({
				...rest,
				gold_color:  material_type,
				gold_weight: karat
			  }))
			: null;

		const useApiData = !!(this.props.fieldSchema?.useApiData && variantApiData);

		if(!dataKey) {
			return null;
		}

		for(const label of labels) {
			let variants = [];
			if(label === '14k') {
				variants = useApiData
					? variantApiData.filter(el => (el.gold_weight || '').toLowerCase() === label.toLowerCase())
					: this.props.product?.variants.filter(el => el.gold_weight.toLowerCase() === label.toLowerCase());
			} else if(label === '18k') {
				variants = useApiData
					? variantApiData.filter(el => (el.gold_weight || '').toLowerCase() === label.toLowerCase())
					: this.props.product?.variants.filter(el => el.gold_weight.toLowerCase() === label.toLowerCase());
			} else if(label === 'Platinum') {
				variants = useApiData
					? variantApiData.filter(el => (el.gold_color || '').toLowerCase() === 'plat')
					: this.props.product?.variants.filter(el => el.gold_color.toLowerCase() === label.toLowerCase());
			}

			if(variants.length > 0) {
				const rangeValue = this.formatRange(variants, dataKey, this.props.fieldSchema?.formatOnDisplay);
				if(rangeValue) {
					respData[label] = rangeValue;
				}
			}
		}

		// Sort user-entered variants
		if(variantApiData === null) {

			const nonStandardVariants = this.props.product?.variants.filter(el => !['14k', '18k'].includes(el.gold_weight.toLowerCase()) && el.gold_color.toLowerCase() !== 'platinum');
			const uniqueSortedWeights = [
				...new Set(
					nonStandardVariants
					.map(v => v.gold_weight)
					.filter(w => typeof w === 'string' && w.trim() !== '')
				)
			].sort((a, b) =>
				a.localeCompare(b, undefined, { sensitivity: 'base' })
			);

			for(const label of uniqueSortedWeights) {
				const variants = this.props.product?.variants.filter(el => el.gold_weight === label);
				if(variants.length > 0) {
					const rangeValue = this.formatRange(variants, dataKey, this.props.fieldSchema?.formatOnDisplay);
					if(rangeValue) {
						respData[label] = rangeValue;
					}
				}
			}
		}

		if(Object.keys(respData).length === 0) {
			return <div className={styles.variantDataMissing}>{`Please call DDNY jewelry concierge for ${dataKey}.`}</div>
			// if(this.props.fieldSchema?.useApiData) {
			// 	return <div className={styles.variantDataMissing}>Please call DDNY jewelry concierge for pricing.</div>
			// }
			// return null;
		}

		return <div className={styles.variantValues}>
			{Object.keys(respData).map((key, i) => {

				if(!respData[key]) {
					return null;
				}

				return <div className={styles.variantRow} key={i}>
					<div className={styles.rowLabel}>{key}</div>
					<div className={styles.rowValue}>{respData[key]}</div>
				</div>
			})}
		</div>
	}

	render() {
		return <div className={styles.ViewSectionElement}>
			<div className={styles.elemWrapper}>
				<div className={styles.label}>{this.props.label}</div>
				{this.props.fieldSchema?.variantDisplay
					? <div className={styles.value}>
						{this.formatVariantValues()}
					  </div>
					: <div 
						className={styles.value}
						dangerouslySetInnerHTML={{
							__html: this.formatValue(),
						}} />
				}
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(ViewSectionElement);